import {_} from 'lodash';
import {global} from "../appContext";
import {IOrganization, ISearchParams} from "../index";
import {IComponentDialogParams, IDialog} from "../component/modal/component";
import * as ko from "knockout";
import {memoryStore} from "../util/memorystore";
import {TComponentName} from "../constants/ComponentRegistry";
import {nsFa} from "../component/fa/fn";
import {ICloneDialogOptions} from "./index";

export interface ICopyWizardDialogContentParams {
    item?: any;
    selectedObjects?: any[];
    options?: ICloneDialogOptions;
    requestParams?: ISearchParams;
}

export namespace nsClone {

    import i = nsFa.i;
    export const targetOrg: KnockoutObservable<IOrganization> = memoryStore.get("clone.target.organization");

    /** Opens a copy wizard via dialog manager (fit-content width, not full viewport). */
    export function openCopyWizardDialog(
        title: string,
        templateName: TComponentName,
        contentParams: ICopyWizardDialogContentParams,
    ) {
        return global.dialogManager.addComponent({
            title,
            fullWidth: false,
            isClosable: ko.observable(true),
            content: {
                name: templateName,
                params: contentParams,
            },
        });
    }

    export function dialogCopyFromSearch(
        title: string,
        templateName: TComponentName,
        selectedObjects: any[],
        requestParams: ISearchParams,
    ) {
        return nsClone.openCopyWizardDialog(title, templateName, {selectedObjects, requestParams});
    }

    export function dialog(options: ICloneDialogOptions, templateName: TComponentName, item?: any) {
        const dialog: IDialog = {
            title: ko.observable(options.title ?? ''),
            closeable: ko.observable(true),
        };
        const params: IComponentDialogParams = {
            dialog: dialog,
            component: {
                name: templateName,
                params: {dialog: dialog, item: item, options}
            }
        };
        global.dialogComponent(params);
    }

    export function dialogCopy(options: ICloneDialogOptions, templateName: TComponentName, item: any) {
        const title = `${i('fa-copy')} ((copy subject|s:((${options.translationKey}|ac)))) [${item.name}]`;
        return nsClone.openCopyWizardDialog(title, templateName, {item, options});
    }

    export function dialogDelete(options: ICloneDialogOptions, templateName: TComponentName, item: any) {
        const title = `${i('fa-trash-alt')} ((delete subject|s:((${options.translationKey}|ac)))) [${item.name}]`;
        return nsClone.dialog(_.defaultsDeep({title}, options), templateName, item)
    }

}
